export const crmIntegrationsKeys = {
  vinsolutionUsers: () => ['VINSOLUTION_USERS'] as const,
  vinsolutionUsersList: (dealerId: number) =>
    ['VINSOLUTION_USERS', dealerId] as const,
  accountManagers: () => ['ACCOUNT_MANAGERS'] as const,
};
